export default "__VITE_ASSET__CHC16AmN__"